import React from 'react';
import moment from 'moment';
import { injectIntl } from 'react-intl';
import DateStamp from '@bibliocommons/date-stamp';
import { cardShape } from '@bibliocommons/bc-prop-types';

export function EventDateStamp({ card, intl }) {
  if (card.get('event')) {
    const date = moment.utc(card.getIn(['event', 'startTime'])).toDate();
    const month = intl.formatDate(date, { month: 'short' });
    const day = intl.formatDate(date, { day: 'numeric' });

    return <DateStamp className="cp-event-date-stamp" size="large" month={month} day={day} />;
  }

  return null;
}

EventDateStamp.propTypes = {
  card: cardShape.isRequired
};

export default injectIntl(EventDateStamp);
